export default {"src":"/_next/static/media/dark-list-icon.d51a7ad6.svg","height":64,"width":64};